<template>
  <div class="contact-form">
    <h2 class="contact-header">Contact Us</h2>
    <div class="contact-container">
      <form
        v-if="!showSpinner"
        @submit.prevent="handleSubmit"
      >
        <h2 class="form-header">Send Us A Message</h2>
        <label>Name
          <input
          v-model="name"
          type="text"
          required
          placeholder="Full Name"
        ></label>
        <label>Title
          <input
          v-model="prenom"
          type="text"
          required
          placeholder="Dr/Mr/Mrs/Ms..."
        >
        </label>
        <label>Phone
        <input
          v-model="phone"
          type="text"
          required
          placeholder="Phone"
        >
        </label>
        <label>Email
        <input
          v-model="email"
          type="text"
          placeholder="Email"
        >
        </label>
        <label>Message
        <textarea
          v-model="message"
          required
        ></textarea>
        </label>
        <br>
        <button>Submit</button>
      </form>
      <div class="getin-touch">
        <h2 class="form-header">Get In Touch</h2>
        <p>Inspire Leadership School, Creating Leaders Through Education</p>
        <h2 class="form-header">Call</h2>
        <p>0978730723<br/>0976130005</p>
        <h2 class="form-header">Email</h2>
        <p>inspireleadershipschool@gmail.com</p>
        <h2 class="form-header">Visit</h2>
        <p>Plot no 31379 off Ring Road Chalala Lusaka, Zambia</p>
      </div>
    </div>
    <div class="footer-map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3845.6953770168543!2d28.349443315017457!3d-15.446984118621321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19408c54ac0526bd%3A0xf7969458efffeb6d!2sInspire%20Leadership%20School!5e0!3m2!1sen!2szm!4v1651520823014!5m2!1sen!2szm" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
    <Spinner v-if="showSpinner" />
    <div v-if="error" class="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import useLoginAnon from '@/composables/useLoginAnon'
import useLogout from '@/composables/useLogout'
import { db, serverTimestamp, addDoc, collection } from '@/firebase/config'
import { useRouter } from 'vue-router'
import Spinner from '@/components/Spinner.vue'

export default {
  components: { Spinner },
  setup (props, context) {
    const email = ref('')
    const name = ref('')
    const prenom = ref('')
    const phone = ref('')
    const message = ref('')
    const showSpinner = ref(false)
    const router = useRouter()

    const { error, loginAnon, user } = useLoginAnon()
    const { logout } = useLogout()

    const handleSubmit = async () => {
      showSpinner.value = true
      const post = {
        name: name.value,
        prenom: prenom.value,
        email: email.value,
        phone: phone.value,
        message: message.value,
        createdAt: serverTimestamp()
      }

      if (!error.value) {
        if (user) {
          await addDoc(collection(db, '/schools/inspire-schools/contact-form'), post)
        }
        await logout()
        router.push({ name: 'Home' })
      }
    }

    onMounted(async () => {
      await loginAnon()
    })

    onBeforeUnmount(async () => {
      if (user) {
        await logout()
      }
    })
    return { email, name, message, prenom, handleSubmit, error, phone, showSpinner }
  }
}
</script>

<style>
.contact-form .contact-container {
  width: 100%;
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
}
.contact-form form {
  width: 100%;
  margin: 30px auto;
  background: transparent;
}
.contact-form .getin-touch {
  margin: 30px auto;
  text-align: left;
  padding: 40px;
  color: #fff;
}
.contact-form .error {
  font-size: 1.1em;
}
.contact-form .contact-header {
  padding-top: 1.5em;
  text-transform: uppercase;
  font-size: 2em;
  font-weight: bold;
  color: #fff;
  text-decoration: underline;
}
.contact-form .form-header {
  color: #fff;
  font-weight: bold;
  font-size: 1.5em;
  margin-bottom: 1em;
}
.contact-form label {
  display: inline;
}
.contact-form textarea {
  display: block;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 10px;
  resize: vertical;
  height: 200px;
}
.contact-form input, select {
  border: skyblue;
  border: 1px solid #ddd;
  border-radius: 10px;
}
.contact-form input:focus, select:focus, textarea:focus {
  outline: skyblue;
  border: 1px solid skyblue;
}
.contact-form .contact {
  display: grid;
  place-items: center;
}
.contact-form .contact .socials {
  justify-content: center;
}
.contact-form button {
  font-weight: bold;
  font-size: 1.3em;
}
.contact-form .getin-touch p {
  margin-bottom: 30px;
  font-size: 1.3em;
}
.contact-form .footer-map {
  max-height: 40vh;
}
@media (max-width: 550px) {
  .contact-form .contact-container {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
  .contact-form .getin-touch {
    margin: 0;
    text-align: left;
    padding: 10px;
  }
}
</style>
